var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal_info && _vm.$route.name === 'exchange')?_c('div',{staticClass:"info-bar-wrap"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-bar"},[_c('div',{staticClass:"info-bar__inner"},[_c('img',{attrs:{"src":require("@/assets/media/Icon/Metamask.svg"),"alt":"metamask 메타마스크 icon 아이콘"}}),_c('p',[_vm._v("Please login with Metamask Browser.")])])])
}]

export { render, staticRenderFns }